import { Component, Inject, Input, NgModule, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { SharedModule } from 'src/app/shared.module';
import { I18NEXT_SERVICE } from 'angular-i18next';

/**
 * @title Radios with ngModel
 */
interface Option {
  value: string;
  label?: string;
  requirements?: string[];
}

@Component({
  selector: 'radio-button-group',
  templateUrl: 'radio-button-group.component.html',
  styleUrl: 'radio-button-group.component.scss',
  standalone: true,
  imports: [
    MatRadioModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
  ],
})
export class RadioButtonGroup implements OnInit {
  @Input() selectedBusinessType!: FormControl;
  @Input({ required: true }) businessTypes!: Option[];

  ngOnInit() {
    console.log(this.selectedBusinessType);
  }

  constructor(@Inject(I18NEXT_SERVICE) private i18next: any) {}

  getBusinessLabel(type: string): string {
    return this.i18next.t(`business-types.${type}.label`);
  }

  getRequirements(type: string): string[] {
    return this.i18next.t(`business-types.${type}.requirements`, {
      returnObjects: true,
    });
  }
}
